import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { bootstrapMsal } from './auth/msalInstance';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Initialize MSAL (required in @azure/msal-browser v3) and consume any pending
// redirect response BEFORE React mounts. This prevents login redirect loops.
bootstrapMsal()
  .catch((err) => {
    console.error('MSAL bootstrap failed:', err);
  })
  .finally(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
